import Offcanvas from "react-bootstrap/Offcanvas";

const OffCanvas = ({ children, show, handleClose, title, ...props }) => {
  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement="end" {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <p>{title}</p>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default OffCanvas;
